import { useEffect, useState } from 'react';
import { showAlert } from './components/common/ErrorAlert/ErrorAlert';

// export const useCheckboxClick = (items) => {
//   const [isParentSelected, setIsParentSelected] = useState(false);
//   const [selectedItems, setSelectedItems] = useState([]);


//   const handleParentCheckboxChange = () => {
//     if (items.length > 0) {
//         const newParentState = !isParentSelected;
//         setIsParentSelected(newParentState);

//         if (newParentState) {
//             setSelectedItems(items.map((item) => item.id));
//         } else {
//             setSelectedItems([]);
//         }
//     } else {
//         showAlert("There are no items to select.");
//     }
//   };

//   useEffect(() =>{
//     setSelectedItems([]);
//     setIsParentSelected(false)
//   },[items])



//   const handleChildCheckboxChange = (itemId) => {
//     if (selectedItems.includes(itemId)) {
//       const newSelectedItems = selectedItems.filter((id) => id !== itemId);
//       setSelectedItems(newSelectedItems);
//       setIsParentSelected(false); 
//     } else {
//       const newSelectedItems = [...selectedItems, itemId];
//       setSelectedItems(newSelectedItems);

//       if (newSelectedItems.length === items.length) {
//         setIsParentSelected(true);
//       }
//     }
//   };

//   // New method to reset checkbox state
//   const resetCheckboxState = () => {
//     setSelectedItems([]);
//     setIsParentSelected(false);
//   };

//   return {
//     isParentSelected,
//     selectedItems,
//     handleParentCheckboxChange,
//     handleChildCheckboxChange,
//     resetCheckboxState,  // Add this method to the returned object
//   };
// };

export const useCheckboxClick = (items) => {
  const [isParentSelected, setIsParentSelected] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  const handleParentCheckboxChange = () => {
    if (items.length > 0) {
      const newParentState = !isParentSelected;
      setIsParentSelected(newParentState);

      if (newParentState) {
        const allIds = items.map((item) => item.id || item.product_id);
        setSelectedItems(allIds);
      } else {
        setSelectedItems([]);
      }
    } else {
      showAlert("There are no items to select.");
    }
  };

  useEffect(() => {
    setSelectedItems([]);
    setIsParentSelected(false);
  }, [items]);

  const handleChildCheckboxChange = (itemId) => {
    if (selectedItems.includes(itemId)) {
      const newSelectedItems = selectedItems.filter((id) => id !== itemId);
      setSelectedItems(newSelectedItems);
      setIsParentSelected(false);
    } else {
      const newSelectedItems = [...selectedItems, itemId];
      setSelectedItems(newSelectedItems);

      if (newSelectedItems.length === items.length) {
        setIsParentSelected(true);
      }
    }
  };

  const resetCheckboxState = () => {
    setSelectedItems([]);
    setIsParentSelected(false);
  };

  return {
    isParentSelected,
    selectedItems,
    handleParentCheckboxChange,
    handleChildCheckboxChange,
    resetCheckboxState,
  };
};
